module.exports = __webpack_public_path__ + "media/images/landing/client_Lionsgate-a975ba3e51d9e4e3681f4944ea563402.png";